import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.boundHandleDocumentClick = this.handleDocumentClick.bind(this)
    this.boundHandleEscape = this.handleEscape.bind(this)
    this.boundPositionMenu = this.positionMenu.bind(this)
    document.addEventListener("click", this.boundHandleDocumentClick)
    document.addEventListener("keydown", this.boundHandleEscape)
    window.addEventListener("resize", this.boundPositionMenu)
    this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleDocumentClick)
    document.removeEventListener("keydown", this.boundHandleEscape)
    window.removeEventListener("resize", this.boundPositionMenu)
  }

  toggle(event) {
    event.preventDefault()
    const isHidden = this.menuTarget.classList.toggle("hidden")
    this.buttonTarget.setAttribute("aria-expanded", (!isHidden).toString())
    if (!isHidden) this.positionMenu()
  }

  positionMenu() {
    if (this.menuTarget.classList.contains("hidden")) return

    this.menuTarget.style.transform = ""
    const { left, right } = this.menuTarget.getBoundingClientRect()
    const gutter = 8
    const viewportWidth = document.documentElement.clientWidth
    const offset = left < gutter ? gutter - left : Math.min(0, viewportWidth - gutter - right)
    this.menuTarget.style.transform = `translateX(${offset}px)`
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  handleEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
